import { BehaviorSubject } from 'rxjs';

export const navbarSyncDataSubject$ = new BehaviorSubject<SyncDataSubject | null>(null);

export enum SyncDataSubject {
  USER_PROFILE = 'USER_PROFILE',
  SAVED_SEARCH = 'SAVED_SEARCH',
}
